import { Component, EventEmitter, Input, OnDestroy, Output, ViewChild, ViewContainerRef } from '@angular/core';
import { WidgetType } from '../../widgets/shared/widget-type.enum';
import { DashboardService } from '../../dashboard.service';
import { AbstractWidgetComponent, ParameterChangedData, WidgetMode } from '../../widgets/shared/abstract-widget.component';
import { Subscription } from 'rxjs';

@Component({
    selector: 'app-add-widget-dialog-component-preview',
    imports: [],
    templateUrl: './add-widget-dialog-component-preview.component.html',
    styleUrl: './add-widget-dialog-component-preview.component.scss'
})
export class AddWidgetDialogComponentPreviewComponent implements OnDestroy{

  @ViewChild('viewContainer2', {read: ViewContainerRef, static: true})
  public viewContainer: ViewContainerRef;

  @Input()
  public set selectedWidgetType(type: WidgetType) {
    this._selectedWidgetType = type;
    this.viewContainer.clear();
    if (type != null) {
      const widget = this.dashboardService.getWidgetClass(type);
      if (widget == null) {
        return;
      }
      var component = this.viewContainer.createComponent(widget);
      const instance = component.instance as AbstractWidgetComponent;
      instance.isPersonalMode = this.dashboardService.isPersonalMode(type);
      instance.mode = WidgetMode.Preview;
      this.subscriptions.add(instance.parametersChanged.subscribe((data: ParameterChangedData) => this.handleWidgetParameterChanged(data)));
    }
  };

  @Output()
  public widgetSelected: EventEmitter<ParameterChangedData> = new EventEmitter<ParameterChangedData>();

  private subscriptions = new Subscription();

  protected _selectedWidgetType: WidgetType;

  constructor(private dashboardService: DashboardService) {
  }

  ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  private handleWidgetParameterChanged(data: ParameterChangedData) {
    this.widgetSelected.emit(data);
  }

}
